module.exports = __webpack_public_path__ + "files/80b0c8b6c37726dc8fe1a3fd881da665.png";